var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItsReallyRewarding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 193,
    viewBox: "0 0 235 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7245 53.8096C15.5926 58.8189 25.8413 90.8112 27.3712 96.0259",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9146 97.1769C24.4358 96.2201 33.8651 96.1474 38.0193 92.2023",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62399 57.029C8.10447 55.2931 20.4109 51.3036 24.3108 49.6995",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9088 44.5908C45.4976 53.7596 47.0865 62.9284 48.6754 72.0972C49.7018 78.0199 51.4516 83.3032 53.2689 89.0031C53.9504 91.1403 54.573 94.1179 56.0974 95.7231",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6413 65.0197C37.1438 64.0661 42.6658 63.189 48.1541 62.1581C52.6742 61.3091 56.737 59.0069 61.2459 58.2255",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1332 43.3301C63.8153 47.2659 67.0555 50.4721 67.6967 54.1725",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9703 63.4834C84.2973 59.6001 78.2996 57.7965 75.8599 61.259C74.7 62.9051 73.3747 66.2824 73.7311 68.3394C74.0844 70.3778 77.0242 71.1244 78.9774 70.786C80.9718 70.4404 83.2438 69.7419 85.2474 70.2463C87.2282 70.745 88.365 75.7227 87.6056 77.5434C86.7376 79.6247 85.1794 81.3519 83.0328 82.139C79.2598 83.5224 75.9756 85.6239 71.9263 86.3257",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.345 47.8747C114.816 50.5926 115.246 53.3213 115.759 56.0315C116.344 59.126 117.23 62.2836 117.766 65.3793C118.063 67.092 118.545 70.8248 119.042 72.7421",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.198 47.0056C112.474 47.3045 117.604 46.108 119.18 45.3468C120.755 44.5866 122.886 45.6402 123.621 47.1624C124.977 49.9704 126.873 56.6334 123.486 58.7195C122.41 59.3829 119.56 60.1572 117.049 60.5924C121.297 59.8563 129.386 65.4673 131.239 68.9145",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.021 55.8635C158.078 45.9768 135.76 37.8831 132.653 47.2736C131.265 52.3311 132.581 53.3682 133.004 55.8115C133.973 58.8905 136.12 66.4515 150.7 62.3181",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.562 43.3246C163.091 40.6114 161.021 37.9219 157.978 37.0073C154.658 36.009 152.341 42.4288 151.988 44.7566C151.533 47.7704 150.81 52.2162 152.662 54.9557C154.278 57.3458 158.899 58.8707 161.596 57.8818C164.498 56.8176 163.597 47.6412 163.622 45.475C163.654 42.6501 163.221 40.0057 162.739 37.2261C162.491 35.7927 162.229 34.2796 162.631 36.5987C163.277 40.3319 164.121 43.5922 166.513 46.6643C167.366 47.7601 169.383 51.4848 170.645 51.8642",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.162 8.6875C165.177 13.5401 176.549 45.9886 178.827 50.7053",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.406 6.58691C172.013 12.3206 174.172 16.9219 176.38 21.9996C177.945 25.5991 184.852 44.0786 185.667 47.8999",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M187.999 27.8167C188.947 33.2875 190.08 37.8708 192.734 42.8054C193.492 44.2166 194.548 46.332 196.223 46.8739C197.772 47.375 198.398 42.969 198.496 42.2045C199.076 37.656 198.9 32.8307 198.342 28.2615C198.277 27.7313 197.42 22.799 197.697 24.3961C198.525 29.1767 200.149 32.5852 203.042 36.5944C208.624 44.3288 214.415 52.0568 218.37 60.784C218.67 61.4465 220.051 64.7032 219.513 65.6569C218.774 66.9649 216.741 67.1316 215.481 67.3499C211.138 68.1025 206.743 69.2312 202.312 68.9607C200.662 68.86 193.303 68.9987 195.691 65.609C198.458 61.6826 201.212 55.6151 205.923 53.7935",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0433 111.865C26.6766 117.555 27.3098 123.245 27.9431 128.935C28.1644 130.923 28.6647 135.416 28.9374 137.873",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5968 111.175C27.9855 110.909 31.8962 109.615 34.0528 110.808C35.8276 111.791 36.4757 114.154 35.662 116.048C34.6773 118.339 33.6096 120.693 32.0457 122.648C31.8251 122.924 28.9949 125.415 29.2505 123.903C29.4441 122.758 33.5488 124.657 36.489 125.969C39.3418 127.407 43.6661 130.497 44.213 135.411",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7552 120.182C56.4776 119.366 56.3485 112 56.0666 109.466C55.2804 102.402 46.2874 106.777 43.2422 109.568C41.7809 110.907 40.9577 113.126 41.5303 118.267C42.0478 122.915 42.1133 122.627 43.6555 126.38C45.1977 130.132 50.035 134.803 59.0398 129.72",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2032 105.57C59.663 105.939 66.0897 120.653 66.4368 122.72C66.787 124.806 68.2875 128.129 68.4958 123.887C68.6786 120.165 70.3609 116.575 70.5527 113.047C70.6336 111.558 71.3504 114.048 71.4427 114.405C71.8275 115.895 73.5092 117.751 74.525 118.865C75.384 119.806 76.1626 121.204 77.2421 121.887C78.5026 122.684 77.8027 118.888 77.7753 118.195C77.5393 112.228 78.6504 106.326 77.9883 100.377",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4893 99.4565C94.2778 98.7134 89.8657 99.6058 88.5904 100.163C84.6959 101.864 83.3967 103.681 83.3974 107.903C83.3977 109.675 83.601 112.208 84.5148 113.696C85.3105 114.992 87.2115 117.033 89.0327 117.23C92.4185 117.597 94.0313 113.54 94.6044 110.863C95.4089 107.106 95.3961 103.183 96.098 99.3888C96.6559 96.3727 96.3549 97.8631 96.3549 97.8631C96.3549 97.8631 96.9762 97.7543 97.4364 101.456C97.8261 104.592 98.9174 111.87 101.157 114.06C102.147 115.029 103.058 114.615 104.29 112.929",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.094 95.8597C105.876 93.9078 106.514 99.8046 107.189 101.648C108.061 104.026 109.317 106.342 110.389 108.64C111.03 110.012 111.305 111.766 112.057 112.928",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.837 94.5233C107.01 92.0807 113.759 90.1292 115.622 93.6924C117.134 96.5844 116.349 101 112.461 101.433C111.963 101.488 108.929 101.826 110.069 101.699C111.887 101.497 114.769 100.726 116.371 101.901C119.606 104.27 122.237 107.201 124.342 110.454",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.843 87.6855C121.69 90.386 122.401 93.5127 123.579 97.8895C124.339 100.713 125.077 104.114 126.024 107.531",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.839 87.5748C120.854 86.426 125.853 86.1479 129.042 86.8013C131.223 87.2484 134.799 90.1916 135.162 93.4513C135.498 96.4721 134.442 103.524 126.862 107.029",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M138.786 83.0732C139.095 85.853 139.64 88.0032 140.441 91.3037C141.084 93.9565 142.945 102.075 143.124 103.678",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M136.8 78.4927C138.007 76.7866 135.57 77.1648 136.313 77.4386",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M145.375 78.9077C145.64 81.2827 146.232 83.5998 146.597 85.961C147.135 89.4423 148.029 93.2479 149.271 96.9904C149.49 97.6506 151.177 101.162 150.889 98.5785C150.282 93.1227 148.403 79.0815 150.197 77.7028C153.783 74.9472 160.075 91.6386 160.723 97.4686",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M170.725 73.563C170.439 71.0016 166.553 70.1174 163.807 70.9722C160.494 72.2734 161.167 75.637 161.439 78.4362C161.934 81.2915 163.096 82.8518 165.167 84.5075C168.651 87.294 171.637 81.5742 171.33 78.8164C171.088 76.6425 170.792 74.4678 170.603 72.2887C170.523 71.3652 170.966 72.2301 171.009 72.613C171.195 74.2913 171.797 75.889 172.37 77.4692C174.48 83.2921 177.599 88.6931 179.512 94.612C180.085 96.3864 180.542 98.4933 179.808 100.223C179.024 102.068 178.082 103.231 176.177 103.931C171.073 105.81 166.277 107.021 160.852 107.484C157.606 107.761 161.076 102.777 162.472 102.132",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "drawable",
    d: "M33.4119 179.568C32.156 172.32 30.9001 165.073 29.6442 157.826C29.6183 157.676 29.0545 155.68 30.0151 156.264C34.6591 159.088 35.427 165.82 37.7073 169.552C41.0847 175.079 45.3873 180.033 50.0266 185.104C51.2796 186.474 52.8086 188.573 56.3084 188.402C61.005 188.173 68.1986 164.668 70.4258 161.386C73.4875 156.874 75.361 154.665 81.2472 158.298C85.8547 161.142 89.1948 164.324 91.968 167.958C94.0559 170.695 95.3998 170.897 97.3669 167.272C101.769 159.161 106.257 151.056 110.602 142.941C111.611 141.057 116.3 129.33 120.999 128.515C123.975 127.999 130.078 147.902 131.68 150.165C135.222 155.168 139.064 148.896 142.131 145.679C145.574 142.066 148.951 138.436 152.442 134.834C155.593 131.583 157.112 137.406 157.98 138.653C158.728 139.728 163.814 150.124 165.944 148.328C171.826 143.37 176.178 137.405 180.322 132.071C183.504 127.976 185.909 123.301 191.545 119.821C197.794 115.96 202.537 121.844 204.888 124.248C207.297 126.713 206.966 127.766 209.273 124.38C212.492 119.654 218.055 129.918 219.351 131.441C224.848 137.901 218.335 110.766 223.688 96.392",
    stroke: "#D9FC51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItsReallyRewarding);
export default __webpack_public_path__ + "static/media/its-really-rewarding.177d4a4ad6039705f6688929f6e3e7e3.svg";
export { ForwardRef as ReactComponent };